import { TaxIdentityFeatureEnum } from '../../components/shared/constants';

export function digitalCertificateValid(tokenExpirationDate) {
    if (!tokenExpirationDate) {
        return false;
    }
    if (typeof tokenExpirationDate == 'string') {
        tokenExpirationDate = new Date(tokenExpirationDate);
    }
    return tokenExpirationDate > new Date();
}

export function getIdentityTaxTypeName(typeId) {
    if (!typeId) {
        return null;
    }
    const taxIdentityName = TaxIdentityFeatureEnum[typeId];
    return taxIdentityName;
}